<template>
  <div
    :class="[
      'page-stack',
      'sms-config-page',
      {
        'is-editing': providerEditId || senderEditId || templateEditId,
        'template-list-mode': active === 'templates',
        'sender-list-mode': active === 'senders',
      },
    ]"
  >
    <el-tabs v-model="active" @tab-click="onTabChange">
      <el-tab-pane label="短信通道" name="providers">
        <div class="list-toolbar">
          <div>
            <h3>短信通道</h3>
            <p>维护短信通道能力与环境；创建、编辑均在弹窗内完成。</p>
          </div>
          <el-button v-if="canAdmin" type="primary" icon="el-icon-plus" @click="openProviderCreate">创建短信通道</el-button>
        </div>
        <section class="surface-card config-filter-bar"><el-input v-model="providerFilter.keyword" clearable placeholder="搜索通道名称 / 编码" prefix-icon="el-icon-search" /><el-select v-model="providerFilter.countryCode" clearable placeholder="全部国家"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select><el-tag type="info">{{ environmentLabel(configurationEnvironment) }}环境</el-tag><el-select v-model="providerFilter.enabled" clearable placeholder="全部状态"><el-option label="启用" value="enabled" /><el-option label="停用" value="disabled" /></el-select><el-button type="primary" @click="applyFilters('providers')">查询</el-button><el-button @click="resetFilters('providers')">重置</el-button></section>
        <el-table ref="providerTable" :data="pagedProviders" v-loading="loading" class="surface-card" :fit="false" @cell-mouse-enter="showRowRemark" @cell-mouse-leave="clearRowRemark"
          ><el-table-column type="index" label="#" width="58" :index="rowIndex(providerPage)" /><el-table-column prop="providerName" label="通道" min-width="180"
            ><template slot-scope="{ row }"
              ><strong>{{ row.providerName }}</strong
              ><br /><small>{{ row.providerCode }}</small></template
            ></el-table-column
          ><el-table-column label="国家" width="105"><template slot-scope="{ row }"><country-badge :code="row.countryCode" /></template></el-table-column><el-table-column label="环境" width="110"><template slot-scope="{ row }">{{ environmentLabel(row.environment) }}</template></el-table-column><el-table-column prop="templateMode" label="模板模式" width="150" /><el-table-column prop="adapterStatus" label="适配器" width="150" /><el-table-column label="状态" width="100"
            ><template slot-scope="{ row }"
              ><el-tag :type="row.enabled ? 'success' : 'info'">{{ row.enabled ? "启用" : "停用" }}</el-tag></template
            ></el-table-column
          ><el-table-column label="发送就绪" min-width="190"
            ><template slot-scope="{ row }"
              ><el-tag :type="providerReadiness(row).type">{{ providerReadiness(row).label }}</el-tag></template
            ></el-table-column
          ><el-table-column class-name="sticky-action-cell" label-class-name="sticky-action-cell" label="操作" width="200"
            ><template slot-scope="{ row }"><el-button size="mini" @click="editProvider(row)" v-if="canAdmin">{{ row.enabled ? '编辑备注' : '编辑' }}</el-button><el-button size="mini" @click="showOperations('provider', row.providerId)">操作记录</el-button><el-button size="mini" type="success" :loading="isActionLoading('providers', row.providerId, 'ENABLE')" @click="runAction('providers', row.providerId, 'ENABLE')" v-if="canAdmin && !row.enabled">启用</el-button><el-button size="mini" type="warning" :loading="isActionLoading('providers', row.providerId, 'DISABLE')" @click="runAction('providers', row.providerId, 'DISABLE')" v-if="canAdmin && row.enabled">停用</el-button></template></el-table-column
          ></el-table
        >
        <el-pagination class="config-pagination" background layout="total, prev, pager, next" :page-size="pageSize" :current-page.sync="providerPage" :total="filteredProviders.length" />
      </el-tab-pane>

      <el-tab-pane label="Sender ID" name="senders">
        <div class="list-toolbar sender-toolbar">
          <div>
            <h3>Sender ID</h3>
            <p>Sender ID + 国家唯一；同一 Sender ID 的各短信通道报备状态逐行展示，创建、编辑均在弹窗内完成。</p>
          </div>
          <el-button v-if="canManage" type="primary" icon="el-icon-plus" @click="openSenderCreate">创建 Sender ID</el-button>
        </div>
        <section class="surface-card sender-filters">
          <el-select v-model="senderFilter.providerId" clearable placeholder="全部短信通道"><el-option v-for="item in providers" :key="item.providerId" :label="item.providerName + ' / ' + environmentLabel(item.environment)" :value="item.providerId" /></el-select><el-select v-model="senderFilter.countryCode" clearable placeholder="全部国家"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select><el-select v-model="senderFilter.category" clearable placeholder="全部业务类型"><el-option v-for="item in senderCategories" :key="item" :value="item" /></el-select><el-select v-model="senderFilter.status" clearable placeholder="全部登记状态"><el-option v-for="item in ['DRAFT', 'SUBMITTED', 'APPROVED']" :key="item" :value="item" /></el-select><el-select v-model="senderFilter.enabled" clearable placeholder="全部启用状态"><el-option label="已启用" value="enabled" /><el-option label="已停用" value="disabled" /></el-select><el-input v-model="senderFilter.keyword" clearable placeholder="搜索 Sender ID / Profile" prefix-icon="el-icon-search" /><el-button type="primary" @click="applyFilters('senders')">查询</el-button><el-button @click="resetFilters('senders')">重置</el-button>
        </section>
        <div class="sender-summary">
          <span>共 {{ filteredSenders.length }} 条</span><el-tag type="success">已启用 {{ filteredSenders.filter((item) => item.enabled).length }}</el-tag
          ><el-tag type="warning">待确认 {{ filteredSenders.filter((item) => item.providerStatus !== "APPROVED").length }}</el-tag>
        </div>
        <el-table ref="senderTable" :data="pagedSenders" class="surface-card" :fit="false" @cell-mouse-enter="showRowRemark" @cell-mouse-leave="clearRowRemark"
          ><el-table-column type="index" label="#" width="58" :index="rowIndex(senderPage)" /><el-table-column prop="senderId" label="Sender ID" min-width="135"
            ><template slot-scope="{ row }"
              ><strong>{{ row.senderId }}</strong
              ><br /><small>{{ row.profileCode }}</small></template
            ></el-table-column
          ><el-table-column prop="providerName" label="短信通道" min-width="160"
            ><template slot-scope="{ row }"
              >{{ row.providerName }}<br /><small>{{ environmentLabel(row.environment) }}</small></template
            ></el-table-column
          ><el-table-column label="国家" width="105"><template slot-scope="{ row }"><country-badge :code="row.countryCode" /></template></el-table-column><el-table-column prop="category" label="业务类型" min-width="145" /><el-table-column prop="providerStatus" label="登记状态" width="120"
            ><template slot-scope="{ row }"
              ><el-tag size="mini" :type="row.providerStatus === 'APPROVED' ? 'success' : row.providerStatus === 'SUBMITTED' ? 'warning' : 'info'">{{ row.providerStatus }}</el-tag></template
            ></el-table-column
          ><el-table-column label="启用状态" width="90"
            ><template slot-scope="{ row }"
              ><el-tag :type="row.enabled ? 'success' : 'info'">{{ row.enabled ? "启用" : "停用" }}</el-tag></template
            ></el-table-column
          ><el-table-column class-name="sticky-action-cell" label-class-name="sticky-action-cell" label="操作" width="270"
            ><template slot-scope="{ row }"><el-button size="mini" @click="editSender(row)" v-if="canManage">编辑/新增通道</el-button><el-button size="mini" @click="showOperations('sender', row.senderProfileId)">操作记录</el-button><el-button size="mini" type="success" :loading="isActionLoading('senders', row.registrationId, 'ENABLE')" @click="runAction('senders', row.registrationId, 'ENABLE')" v-if="canManage && !row.enabled">一键启用</el-button><el-button size="mini" type="warning" :loading="isActionLoading('senders', row.registrationId, 'DISABLE')" @click="runAction('senders', row.registrationId, 'DISABLE')" v-if="canManage && row.enabled">停用</el-button></template></el-table-column
          ></el-table
        >
        <el-pagination class="config-pagination" background layout="total, prev, pager, next" :page-size="pageSize" :current-page.sync="senderPage" :total="filteredSenders.length" />
      </el-tab-pane>

      <el-tab-pane label="短信模板" name="templates">
        <div class="list-toolbar" v-if="canManage">
          <div>
            <h3>短信模板</h3>
            <p>创建和编辑均在弹窗内完成。</p>
          </div>
          <el-button type="primary" icon="el-icon-plus" @click="openTemplateCreate">创建模板</el-button>
        </div>
        <section class="surface-card config-filter-bar"><el-input v-model="templateFilter.keyword" clearable placeholder="搜索模板编码 / 名称 / 场景 / 正文" prefix-icon="el-icon-search" /><el-select v-model="templateFilter.countryCode" clearable placeholder="全部国家"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select><el-select v-model="templateFilter.productLine" clearable placeholder="全部产品线"><el-option v-for="item in productLines" :key="item" :value="item" /></el-select><el-select v-model="templateFilter.versionScope" placeholder="版本范围"><el-option label="最新版本" value="latest" /><el-option label="历史版本" value="history" /></el-select><el-select v-model="templateFilter.state" clearable placeholder="全部状态"><el-option v-for="item in ['DRAFT', 'PUBLISHED', 'DISABLED', 'SUPERSEDED']" :key="item" :value="item" /></el-select><el-button type="primary" @click="applyFilters('templates')">查询</el-button><el-button @click="resetFilters('templates')">重置</el-button></section>
        <el-table ref="templateTable" :data="pagedTemplates" class="surface-card" :fit="false"
          ><el-table-column type="index" label="#" width="58" :index="rowIndex(templatePage)" /><el-table-column prop="templateCode" label="模板编码" min-width="170" /><el-table-column prop="templateName" label="名称" min-width="140" /><el-table-column prop="productLine" label="产品线" width="120"><template slot-scope="{ row }">{{ row.productLine || "—" }}</template></el-table-column><el-table-column prop="scene" label="调用场景" min-width="150" /><el-table-column prop="messageType" label="运营分类" width="120" /><el-table-column label="模板文本" min-width="280"><template slot-scope="{ row }"><el-tooltip :content="row.contentTemplate" placement="top" :open-delay="300"><div class="template-content-cell">{{ row.contentTemplate }}</div></el-tooltip></template></el-table-column><el-table-column label="国家" width="105"><template slot-scope="{ row }"><country-badge :code="row.countryCode" /></template></el-table-column><el-table-column prop="operationState" label="状态" width="100" /><el-table-column prop="version" label="版本" width="70" /><el-table-column label="最后更新" min-width="150"><template slot-scope="{ row }">{{ row.updateUser || "—" }}<br /><small>{{ formatDate(row.updateTime) }}</small></template></el-table-column><el-table-column class-name="sticky-action-cell" label-class-name="sticky-action-cell" label="操作" width="200"
            ><template slot-scope="{ row }"><div class="table-actions"><el-button size="mini" @click="editTemplate(row)" v-if="canManage && ['DRAFT', 'PUBLISHED'].includes(row.operationState)">编辑</el-button><el-button size="mini" @click="showOperations('template', row.templateId)">操作记录</el-button><el-button size="mini" type="success" :loading="isActionLoading('templates', row.templateId, 'ENABLE')" @click="runAction('templates', row.templateId, 'ENABLE')" v-if="canManage && ['DRAFT', 'DISABLED'].includes(row.operationState)">{{ row.operationState === 'DRAFT' ? '一键启用' : '重新启用' }}</el-button><el-button size="mini" type="warning" :loading="isActionLoading('templates', row.templateId, 'DISABLE')" @click="runAction('templates', row.templateId, 'DISABLE')" v-if="canManage && row.enabled">停用</el-button></div></template></el-table-column
          ></el-table
        >
        <el-pagination class="config-pagination" background layout="total, prev, pager, next" :page-size="pageSize" :current-page.sync="templatePage" :total="filteredTemplates.length" />
      </el-tab-pane>

      <el-tab-pane label="旧版模板通道配置" name="legacyBindings">
        <div class="list-toolbar">
          <div>
            <h3>模板通道配置</h3>
            <p>组合业务模板、短信通道与 Sender ID；创建、编辑均在弹窗内完成。</p>
          </div>
          <el-button v-if="canManage" type="primary" icon="el-icon-plus" @click="openBindingCreate">创建模板通道配置</el-button>
        </div>
        <el-dialog :title="bindingEditId ? '编辑模板通道配置' : '创建模板通道配置'" :visible.sync="bindingEditVisible" width="900px" @closed="cancelEdit">
          <h3>{{ bindingEditId ? "编辑模板通道配置" : "新增模板通道配置" }}</h3>
          <el-alert title="模板决定发送内容，Sender ID 决定用户看到的发送方，短信通道决定由哪家通道送达。" type="info" :closable="false" show-icon /><el-form :model="bindingForm" label-width="112px" class="compact-form binding-form"
            ><el-row :gutter="16"
              ><el-col :span="8"
                ><el-form-item label="1. 业务模板"
              ><el-select v-model="bindingForm.templateId" :disabled="Boolean(bindingEditId)" @change="resetBindingSelection"><el-option v-for="item in templates.filter((template) => template.operationState === 'PUBLISHED' && template.enabled)" :key="item.templateId" :label="item.templateCode + ' / ' + item.countryCode + ' / ' + item.messageType" :value="item.templateId" /></el-select></el-form-item></el-col
              ><el-col :span="8"
                ><el-form-item label="2. Sender ID"
                  ><el-select v-model="bindingForm.senderProfileId" clearable :disabled="!bindingForm.templateId" placeholder="先选择已报备的 Sender ID" @change="bindingSenderChanged"><el-option v-for="item in eligibleBindingSenders" :key="item.senderProfileId" :label="item.senderId + ' · ' + item.profileCode + ' · ' + item.category" :value="item.senderProfileId" /></el-select><small class="field-help" v-if="bindingForm.templateId && !eligibleBindingSenders.length">当前范围没有业务类型匹配的已确认 Sender ID，请先完成短信通道报备。</small></el-form-item
              ></el-col
              ><el-col :span="8"
                ><el-form-item label="3. 短信通道"
                  ><el-select v-model="bindingForm.providerId" :disabled="Boolean(bindingEditId) || !bindingForm.senderProfileId" placeholder="由 Sender ID 报备关系自动带出"><el-option v-for="item in bindingProviders" :key="item.providerId" :label="item.providerName + ' / ' + environmentLabel(item.environment)" :value="item.providerId" /></el-select><small class="field-help" v-if="bindingForm.senderProfileId">仅显示该 Sender ID 已报备的短信通道。</small></el-form-item
                ></el-col
              ></el-row
            ><el-form-item label="环境"><el-tag :type="bindingEnvironment === 'production' ? 'danger' : 'info'">{{ bindingEnvironment ? environmentLabel(bindingEnvironment) : "选择模板后自动确定" }}</el-tag><small class="field-help">模板与短信通道必须属于同一环境。</small></el-form-item
            ><el-row :gutter="16"
              ><el-col :span="12"
                ><el-form-item label="通道模板 ID"><el-input v-model="bindingForm.providerTemplateId" :disabled="selectedBindingProvider && selectedBindingProvider.templateMode === 'RAW_CONTENT'" placeholder="网关正文模式无需填写" /></el-form-item></el-col
              ><el-col :span="12"
                ><el-form-item label="参数顺序"><div class="binding-parameter-order"><span v-for="(name, index) in bindingForm.parameterOrder" :key="name" class="parameter-chip" :draggable="canManage" @dragstart="bindingParameterDragStart(index)" @dragover.prevent @drop="bindingParameterDrop(index)">{{ index + 1 }}. {{ name }}</span><small v-if="!bindingForm.parameterOrder.length" class="field-help">该模板没有变量</small></div><small class="field-help">默认按正文变量出现顺序生成；可拖拽适配通道模板占位符。</small></el-form-item></el-col
            ></el-row>
            <div class="send-preview" v-if="selectedBindingTemplate || selectedBindingProvider">
              <strong>最终发送组合预览</strong><span>通道：{{ selectedBindingProvider ? selectedBindingProvider.providerName + " / " + environmentLabel(selectedBindingProvider.environment) : "未选择" }}</span
              ><span>用户看到的发送方：{{ selectedBindingSender ? selectedBindingSender.senderId : "未选择" }}</span
              ><span>模板内容：{{ selectedBindingTemplate ? selectedBindingTemplate.contentTemplate : "未选择" }}</span>
            </div>
            <el-button type="primary" :loading="saving" @click="saveBinding">{{ bindingSaveLabel() }}</el-button
            ><el-button v-if="bindingEditId" @click="resetEditor">取消编辑</el-button></el-form
          >
        </el-dialog>
        <section class="surface-card config-filter-bar"><el-input v-model="bindingFilter.keyword" clearable placeholder="搜索模板 / Template ID" prefix-icon="el-icon-search" /><el-select v-model="bindingFilter.providerId" clearable placeholder="全部短信通道"><el-option v-for="item in providers" :key="item.providerId" :label="item.providerName + ' / ' + environmentLabel(item.environment)" :value="item.providerId" /></el-select><el-tag type="info">{{ environmentLabel(configurationEnvironment) }}环境</el-tag><el-select v-model="bindingFilter.state" clearable placeholder="全部状态"><el-option v-for="item in ['DRAFT', 'PUBLISHED', 'DISABLED', 'SUPERSEDED']" :key="item" :value="item" /></el-select><el-button type="primary" @click="applyFilters('bindings')">查询</el-button><el-button @click="resetFilters('bindings')">重置</el-button></section>
        <el-table ref="bindingTable" :data="pagedBindings" class="surface-card" :fit="false"
          ><el-table-column type="index" label="#" width="58" :index="rowIndex(bindingPage)" /><el-table-column prop="templateCode" label="模板" min-width="170" /><el-table-column prop="providerName" label="短信通道" min-width="160"><template slot-scope="{ row }">{{ row.providerName || row.providerCode }}<br /><small>{{ row.providerCode }}</small></template></el-table-column><el-table-column label="国家" width="105"><template slot-scope="{ row }"><country-badge :code="row.countryCode" /></template></el-table-column><el-table-column label="环境" width="90"><template slot-scope="{ row }"><el-tag size="mini" :type="row.environment === 'production' ? 'danger' : 'info'">{{ environmentLabel(row.environment) }}</el-tag></template></el-table-column><el-table-column prop="senderProfileCode" label="Sender ID" min-width="150"><template slot-scope="{ row }">{{ row.senderId || "—" }}<br /><small>{{ row.senderProfileCode || "无需 Sender ID" }}</small></template></el-table-column><el-table-column prop="providerTemplateId" label="通道模板 ID" min-width="130" /><el-table-column label="当前发送" width="105"><template slot-scope="{ row }"><el-tag :type="row.selectedForSending ? 'success' : 'info'">{{ row.selectedForSending ? "正在使用" : "备用配置" }}</el-tag></template></el-table-column><el-table-column prop="operationState" label="状态" width="100" /><el-table-column class-name="sticky-action-cell" label-class-name="sticky-action-cell" label="操作" width="250"
            ><template slot-scope="{ row }"><el-button size="mini" @click="editBinding(row)" v-if="canManage && ['DRAFT', 'PUBLISHED'].includes(row.operationState)">编辑</el-button><el-button size="mini" @click="showOperations('binding', row.bindingId)">操作记录</el-button><el-button size="mini" type="success" :loading="isActionLoading('bindings', row.bindingId, 'PUBLISH')" @click="runAction('bindings', row.bindingId, 'PUBLISH')" v-if="canManage && row.operationState === 'DRAFT'">发布</el-button><el-button size="mini" type="primary" :loading="isActionLoading('bindings', row.bindingId, 'SELECT_FOR_SENDING')" @click="runAction('bindings', row.bindingId, 'SELECT_FOR_SENDING')" v-if="canManage && row.enabled && row.operationState === 'PUBLISHED' && !row.selectedForSending">设为发送配置</el-button><el-button size="mini" type="warning" :loading="isActionLoading('bindings', row.bindingId, 'DISABLE')" @click="runAction('bindings', row.bindingId, 'DISABLE')" v-if="canManage && row.enabled && !row.selectedForSending">停用</el-button></template></el-table-column
          ></el-table
        >
        <el-pagination class="config-pagination" background layout="total, prev, pager, next" :page-size="pageSize" :current-page.sync="bindingPage" :total="filteredBindings.length" />
      </el-tab-pane>

      <el-tab-pane label="发送路由" name="bindings">
        <sms-template-route-v2-panel ref="routeV2Panel" :can-manage="canManage" />
      </el-tab-pane>

    </el-tabs>

    <el-dialog title="接入新短信通道" :visible.sync="providerGuideVisible" width="760px">
      <el-steps :active="0" finish-status="success" align-center><el-step title="通道信息" /><el-step title="Sender ID" /><el-step title="模板通道配置" /><el-step title="检查启用" /></el-steps>
      <div class="guide-copy">
        <h3>先创建通道草稿</h3>
        <p>填写国家、环境、接口模式、凭据引用和脱敏 Endpoint。通道可以独立启用；真正发送前，系统还会检查 Sender ID 和模板通道配置。</p>
        <ol>
          <li>创建并启用通道</li>
          <li>为该通道登记 Sender ID，并在操作记录中保留提交、确认和启停历史</li>
          <li>把业务模板、通道和 Sender ID 组成发送组合</li>
          <li>发布模板通道配置并完成发送就绪检查；同一模板有多个可用配置时，明确选择一个“当前发送配置”</li>
        </ol>
      </div>
      <span slot="footer"><el-button @click="providerGuideVisible = false">取消</el-button><el-button type="primary" @click="startProviderOnboarding">开始填写通道</el-button></span>
    </el-dialog>

    <el-dialog :title="providerEditId ? '编辑短信通道' : '创建短信通道'" :visible.sync="providerEditVisible" width="760px" @closed="cancelEdit">
      <el-form :model="providerForm" label-width="112px" class="compact-form">
        <el-form-item label="通道编码"><el-input v-model="providerForm.providerCode" :disabled="Boolean(providerEditId)" placeholder="创建后不可修改" /></el-form-item>
        <el-form-item label="通道名称"><el-input v-model="providerForm.providerName" :disabled="Boolean(providerEditId && providerForm.enabled)" /></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"
            ><el-form-item label="国家"
              ><el-select v-model="providerForm.countryCode" :disabled="Boolean(providerEditId)" placeholder="请选择国家"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select></el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="环境"
              ><el-tag type="info">{{ environmentLabel(configurationEnvironment) }}</el-tag></el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="16"
          ><el-col :span="12"
            ><el-form-item label="模板模式"
              ><el-select v-model="providerForm.templateMode" :disabled="Boolean(providerEditId && providerForm.enabled)"><el-option label="通道模板 ID" value="PROVIDER_TEMPLATE" /><el-option label="网关正文" value="RAW_CONTENT" /></el-select></el-form-item></el-col
          ><el-col :span="12"
            ><el-form-item label="回执模式"
              ><el-select v-model="providerForm.callbackMode" :disabled="Boolean(providerEditId && providerForm.enabled)"><el-option label="回调" value="CALLBACK" /><el-option label="主动查询" value="QUERY" /><el-option label="查询或回调" value="QUERY_OR_CALLBACK" /></el-select></el-form-item></el-col
        ></el-row>
        <el-form-item label="凭据引用"><el-input v-model="providerForm.credentialRef" :disabled="Boolean(providerEditId && providerForm.enabled)" /></el-form-item>
        <el-form-item label="脱敏 Endpoint"><el-input v-model="providerForm.endpointMasked" :disabled="Boolean(providerEditId && providerForm.enabled)" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="providerForm.remark" /></el-form-item>
      </el-form>
      <el-alert v-if="providerEditId && providerForm.enabled" title="已启用通道只允许修改备注；其他配置请先停用通道。" type="info" :closable="false" show-icon />
      <span slot="footer"
        ><el-button :disabled="saving" @click="providerEditVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="saveProvider">{{ providerEditId ? "保存修改" : "创建草稿" }}</el-button></span
      >
    </el-dialog>
    <el-dialog :title="senderEditId ? '编辑 Sender ID' : '创建 Sender ID'" :visible.sync="senderEditVisible" width="780px" @closed="cancelEdit">
      <el-form :model="senderForm" label-width="112px" class="compact-form">
        <el-form-item label="Sender ID"><el-input v-model="senderForm.senderId" placeholder="用户可见的发送方名称" @input="refreshSenderProfileCode" /></el-form-item>
        <el-form-item label="国家"><el-select v-model="senderForm.countryCode" :disabled="Boolean(senderEditId)" placeholder="请选择国家" @change="senderCountryChanged"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select></el-form-item>
        <el-form-item label="报备短信通道">
          <el-checkbox-group v-model="senderForm.providerIds" class="sender-channel-options" @change="refreshSenderProfileCode">
            <el-checkbox v-for="item in senderProviderOptions" :key="item.providerId" :label="item.providerId" :disabled="senderProviderRemovalLocked(item.providerId)" border>
              <strong>{{ item.providerName }}</strong><small>{{ environmentLabel(item.environment) }} · {{ item.providerCode }}</small>
            </el-checkbox>
          </el-checkbox-group>
          <small class="field-help">仅可选择当前环境、该国家下的通道；已提交、已确认或已启用的存量报备不能在此直接移除。</small>
        </el-form-item>
        <div class="sender-channel-list" v-if="selectedSenderChannels.length">
          <div class="sender-channel-row" v-for="item in selectedSenderChannels" :key="item.providerId">
            <span><strong>{{ item.providerName }}</strong><small>{{ countryLabel(item.countryCode) }} / {{ environmentLabel(item.environment) }}</small></span>
            <el-input :value="senderForm.registrationAccountCodes[item.providerId]" @input="$set(senderForm.registrationAccountCodes, item.providerId, $event)" :placeholder="senderAccountCodePlaceholder(item)">
              <template slot="prepend">{{ senderAccountCodeLabel(item) }}</template>
            </el-input>
            <el-tag :type="item.registration && item.registration.providerStatus === 'APPROVED' ? 'success' : 'info'">{{ item.registration ? item.registration.providerStatus : "新增报备" }}</el-tag>
          </div>
        </div>
        <el-form-item label="业务类型"
          ><el-select v-model="senderForm.categories" multiple collapse-tags placeholder="可选择多个，仅用于展示、筛选和统计"><el-option v-for="item in senderCategories" :key="item" :value="item" /></el-select></el-form-item>
        <el-form-item label="Profile 编码"><el-input v-model="senderForm.profileCode" disabled /><small class="field-help">自动生成：国家 + Sender ID + 已选短信通道。</small></el-form-item>
        <el-form-item label="唯一范围"
          ><span>{{ selectedSenderScope }}</span></el-form-item
        >
        <el-form-item label="备注"><el-input v-model="senderForm.remark" /></el-form-item>
      </el-form>
      <el-alert v-if="senderEditId" title="修改 Sender ID 值或业务类型后，各短信通道的报备状态会重置为草稿，需要重新确认并启用；仅增加通道不会影响已有报备。" type="warning" :closable="false" show-icon />
      <span slot="footer"
        ><el-button :disabled="saving" @click="senderEditVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="saveSender">{{ senderEditId ? "保存修改" : "创建草稿" }}</el-button></span
      >
    </el-dialog>
    <el-dialog title="编辑短信模板" :visible.sync="templateEditVisible" width="1040px" top="5vh" custom-class="template-dialog" @closed="cancelEdit">
      <el-form :model="templateForm" label-width="112px" class="compact-form">
        <el-form-item label="模板编码"><el-input v-model="templateForm.templateCode" disabled /></el-form-item>
        <el-row :gutter="16"
          ><el-col :span="8"
            ><el-form-item label="模板名称"><el-input v-model="templateForm.templateName" /></el-form-item></el-col
          ><el-col :span="8"
            ><el-form-item label="产品线"><el-select v-model="templateForm.productLine" placeholder="历史值可为空"><el-option v-for="item in productLines" :key="item" :label="item" :value="item" /></el-select></el-form-item></el-col
          ><el-col :span="8"
            ><el-form-item label="调用场景"><el-select v-model="templateForm.scene" filterable allow-create default-first-option :disabled="templateForm.operationState === 'PUBLISHED'" placeholder="选择或输入新场景"><el-option v-for="item in templateSceneOptions" :key="item" :label="item" :value="item" /></el-select><small class="field-help">调用方路由键；已发布版本不可修改。</small></el-form-item></el-col
        ></el-row>
        <el-row :gutter="16"
          ><el-col :span="8"
            ><el-form-item label="国家"
              ><el-select v-model="templateForm.countryCode" :disabled="templateForm.operationState === 'PUBLISHED'" placeholder="请选择国家"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select></el-form-item></el-col
          ><el-col :span="8"
            ><el-form-item label="运营分类"
              ><el-select v-model="templateForm.messageType" :disabled="templateForm.operationState === 'PUBLISHED'"><el-option v-for="item in messageTypes" :key="item" :value="item" /></el-select></el-form-item></el-col
          ><el-col :span="8"
            ><el-form-item label="语言"><el-input v-model="templateForm.languageCode" /></el-form-item></el-col
        ></el-row>
        <el-alert :title="'变量统一使用命名占位符，例如 {otp}、{customerName}。系统会根据模板文本自动生成变量规则 JSON；不支持 {1} 或 {{otp}}。'" type="info" :closable="false" show-icon />
        <el-form-item label="模板文本"><el-input v-model="templateForm.contentTemplate" type="textarea" :rows="6" placeholder="Your verification code is {otp}." @input="syncTemplateVariableRules" /></el-form-item>
        <el-form-item label="变量规则 JSON"><el-input v-model="templateForm.variableRulesJson" type="textarea" :rows="4" readonly /><small class="field-help">由模板文本自动生成，新变量默认按 text 校验。</small></el-form-item>
      </el-form>
      <el-alert v-if="templateForm.operationState === 'PUBLISHED'" title="保存后将自动生成并发布新版本，后续短信使用新版本；历史发送继续保留原版本快照。" type="info" :closable="false" show-icon />
      <span slot="footer"><el-button :disabled="saving" @click="templateEditVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="saveTemplate">{{ templateForm.operationState === 'PUBLISHED' ? '生成新版本并生效' : '保存修改' }}</el-button></span>
    </el-dialog>

    <el-dialog title="创建短信模板" :visible.sync="templateCreateVisible" width="1040px" top="5vh" custom-class="template-dialog" @closed="cancelTemplateCreate">
      <el-form :model="templateForm" label-width="112px" class="compact-form">
        <el-row :gutter="16"
          ><el-col :span="6"
            ><el-form-item label="模板名称"><el-input v-model="templateForm.templateName" placeholder="例如：登录验证码" @input="templateNameChanged" /></el-form-item></el-col
          ><el-col :span="6"
            ><el-form-item label="产品线"><el-select v-model="templateForm.productLine" placeholder="请选择产品线" @change="templateProductLineChanged"><el-option v-for="item in productLines" :key="item" :label="item" :value="item" /></el-select><small class="field-help">新增模板必须确认产品线；历史模板不改名。</small></el-form-item></el-col
          ><el-col :span="6"
            ><el-form-item label="模板编码"><el-input v-model="templateForm.templateCode" placeholder="根据名称首字母和产品线自动生成" @input="templateCodeChanged" /><small class="field-help">自动生成后仍可修改，例如 dlyzm_kasykredit。</small></el-form-item></el-col
          ><el-col :span="6"
            ><el-form-item label="调用场景"><el-select v-model="templateForm.scene" filterable allow-create default-first-option placeholder="选择或输入新场景"><el-option v-for="item in templateSceneOptions" :key="item" :label="item" :value="item" /></el-select><small class="field-help">这是调用方路由键；已发布版本不可变更。</small></el-form-item></el-col
        ></el-row>
        <el-row :gutter="16"
          ><el-col :span="8"
            ><el-form-item label="国家"
              ><el-select v-model="templateForm.countryCode" placeholder="请选择国家" @change="templateScopeChanged"><el-option label="GH" value="GH"><country-badge code="GH" /></el-option><el-option label="NG" value="NG"><country-badge code="NG" /></el-option></el-select></el-form-item></el-col
          ><el-col :span="8"
            ><el-form-item label="类型"
              ><el-select v-model="templateForm.messageType" placeholder="默认为 OTHER" @change="templateScopeChanged"><el-option v-for="item in messageTypes" :key="item" :value="item" /></el-select><small class="field-help">仅用于运营分类，不限制 Sender ID 或通道。</small></el-form-item></el-col
          ><el-col :span="8"
            ><el-form-item label="语言"><el-input v-model="templateForm.languageCode" /></el-form-item></el-col
        ></el-row>
        <el-alert :title="'变量规范：统一使用命名占位符 {变量名}，例如 {otp}。系统会根据模板文本自动生成变量规则 JSON；不支持 {1} 或 {{otp}}。'" type="info" :closable="false" show-icon />
        <el-form-item label="模板文本"><el-input v-model="templateForm.contentTemplate" type="textarea" :rows="6" placeholder="Your verification code is {otp}." @input="syncTemplateVariableRules" /></el-form-item>
        <el-form-item label="变量规则 JSON"><el-input v-model="templateForm.variableRulesJson" type="textarea" :rows="4" readonly /><small class="field-help">由模板文本自动生成，新变量默认按 text 校验。</small></el-form-item>
        <el-alert title="模板创建不会隐式创建发送链路。保存后请到“发送路由”明确配置候选通道、Sender ID、优先级与启停状态。" type="info" :closable="false" show-icon />
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="templateCreateVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="saveTemplate">创建草稿</el-button></span>
    </el-dialog>

    <el-dialog title="操作记录" :visible.sync="operationsVisible" width="680px"
      ><el-timeline
        ><el-timeline-item v-for="item in operations" :key="item.operationId" :timestamp="formatDate(item.createTime)"
          ><strong>{{ item.action }}</strong> · {{ item.operatorId }}<br /><span>{{ item.detail }}</span></el-timeline-item
        ></el-timeline
      ><el-empty v-if="!operations.length" description="暂无操作记录"
    /></el-dialog>
  </div>
</template>

<script>
import { pinyin } from "pinyin-pro";
import { createSmsConfig, getAdminCapabilities, getSmsConfig, getSmsConfigOperations, getSmsRouteV2Runtime, smsConfigAction, updateSmsConfig } from "../api/admin";
import SmsTemplateRouteV2Panel from "../components/SmsTemplateRouteV2Panel.vue";
import CountryBadge from "../components/CountryBadge.vue";

const blankProvider = () => ({
  providerCode: "",
  providerName: "",
  countryCode: "",
  environment: "test",
  templateMode: "RAW_CONTENT",
  callbackMode: "QUERY_OR_CALLBACK",
  credentialRef: "",
  endpointMasked: "",
  senderRequired: true,
  adapterStatus: "READY",
  remark: "",
});
const blankSender = () => ({
  profileCode: "",
  countryCode: "",
  providerIds: [],
  registrationAccountCodes: {},
  senderId: "",
  categories: ["OTP"],
  remark: "",
});
const blankTemplate = () => ({
  templateCode: "",
  templateName: "",
  productLine: "",
  countryCode: "",
  environment: "test",
  scene: "",
  messageType: "OTHER",
  languageCode: "en",
  contentTemplate: "",
  variableRulesJson: "{}",
  senderProfileId: "",
  providerId: "",
  providerTemplateId: "",
  parameterMappingJson: "{}",
});
const blankBinding = () => ({
  templateId: "",
  providerId: "",
  senderProfileId: "",
  providerTemplateId: "",
  parameterOrder: [],
});
export default {
  name: "SmsConfigurationView",
  components: { SmsTemplateRouteV2Panel, CountryBadge },
  data() {
    return {
      active: "templates",
      configurationEnvironment: "test",
      loading: false,
      saving: false,
      providers: [],
      senders: [],
      templates: [],
      bindings: [],
      operations: [],
      operationsVisible: false,
      operationsTitle: "操作记录",
      actionLoading: {},
      providerGuideVisible: false,
      providerEditVisible: false,
      senderEditVisible: false,
      templateEditVisible: false,
      templateCreateVisible: false,
      bindingEditVisible: false,
      providerEditId: null,
      senderEditId: null,
      templateEditId: null,
      templateCodeEdited: false,
      bindingEditId: null,
      providerForm: blankProvider(),
      senderForm: blankSender(),
      providerFilter: { keyword: "", countryCode: "", environment: "", enabled: "" },
      senderFilter: { providerId: "", countryCode: "", category: "", status: "", enabled: "", keyword: "" },
      templateFilter: { keyword: "", countryCode: "", productLine: "", versionScope: "latest", state: "" },
      bindingFilter: { keyword: "", providerId: "", environment: "", state: "" },
      pageSize: 10,
      providerPage: 1,
      senderPage: 1,
      templatePage: 1,
      bindingPage: 1,
      templateForm: blankTemplate(),
      bindingForm: blankBinding(),
      bindingDraggedParameter: null,
      environments: [],
      messageTypes: ["OTP", "TRANSACTIONAL", "MARKETING", "COLLECTION", "OTHER"],
      productLines: ["KasyKredit", "PocketBuy", "MobiCycle", "RocketCash"],
      senderCategories: ["OTP", "NOTIFICATION", "MARKETING", "COLLECTION", "OTHER"],
    };
  },
  computed: {
    filteredProviders() {
      const keyword = this.providerFilter.keyword.trim().toLowerCase();
      return this.providers.filter((item) => (!keyword || `${item.providerName} ${item.providerCode}`.toLowerCase().includes(keyword)) && (!this.providerFilter.countryCode || item.countryCode === this.providerFilter.countryCode) && (!this.providerFilter.environment || item.environment === this.providerFilter.environment) && (!this.providerFilter.enabled || (this.providerFilter.enabled === "enabled") === Boolean(item.enabled)));
    },
    pagedProviders() {
      return this.paginate(this.filteredProviders, this.providerPage);
    },
    filteredSenders() {
      const keyword = this.senderFilter.keyword.trim().toLowerCase();
      return this.senders.filter((item) => (!this.senderFilter.providerId || item.providerId === this.senderFilter.providerId) && (!this.senderFilter.countryCode || item.countryCode === this.senderFilter.countryCode) && (!this.senderFilter.category || String(item.category || "").split(",").includes(this.senderFilter.category)) && (!this.senderFilter.status || item.providerStatus === this.senderFilter.status) && (!this.senderFilter.enabled || (this.senderFilter.enabled === "enabled") === Boolean(item.enabled)) && (!keyword || `${item.senderId} ${item.profileCode}`.toLowerCase().includes(keyword)));
    },
    pagedSenders() {
      return this.paginate(this.filteredSenders, this.senderPage);
    },
    filteredTemplates() {
      const keyword = this.templateFilter.keyword.trim().toLowerCase();
      return this.templates.filter((item) => (!keyword || `${item.templateCode} ${item.templateName} ${item.productLine || ""} ${item.scene} ${item.contentTemplate || ""}`.toLowerCase().includes(keyword)) && (!this.templateFilter.countryCode || item.countryCode === this.templateFilter.countryCode) && (!this.templateFilter.productLine || item.productLine === this.templateFilter.productLine) && (!this.templateFilter.versionScope || (this.templateFilter.versionScope === "latest") === this.isLatestTemplate(item)) && (!this.templateFilter.state || item.operationState === this.templateFilter.state));
    },
    pagedTemplates() {
      return this.paginate(this.filteredTemplates, this.templatePage);
    },
    latestTemplateIds() {
      const latest = new Map();
      this.templates.forEach((item) => {
        const key = `${item.countryCode}:${String(item.templateCode || "").toLowerCase()}`;
        const prior = latest.get(key);
        if (!prior || Number(item.version || 0) > Number(prior.version || 0)) latest.set(key, item);
      });
      return new Set(Array.from(latest.values()).map((item) => item.templateId));
    },
    templateSceneOptions() {
      return Array.from(new Set(this.templates.map((item) => (item.scene || "").trim()).filter(Boolean))).sort((left, right) => left.localeCompare(right));
    },
    filteredBindings() {
      const keyword = this.bindingFilter.keyword.trim().toLowerCase();
      return this.bindings.filter((item) => (!keyword || `${item.templateCode} ${item.providerTemplateId || ""}`.toLowerCase().includes(keyword)) && (!this.bindingFilter.providerId || item.providerId === this.bindingFilter.providerId) && (!this.bindingFilter.environment || item.environment === this.bindingFilter.environment) && (!this.bindingFilter.state || item.operationState === this.bindingFilter.state));
    },
    pagedBindings() {
      return this.paginate(this.filteredBindings, this.bindingPage);
    },
    roles() {
      return (this.$store.state.user && this.$store.state.user.roles) || [];
    },
    canManage() {
      return this.roles.includes("OPERATOR") || this.roles.includes("ADMIN");
    },
    canAdmin() {
      return this.roles.includes("ADMIN");
    },
    selectedBindingTemplate() {
      return this.templates.find((item) => item.templateId === this.bindingForm.templateId);
    },
    selectedBindingProvider() {
      return this.providers.find((item) => item.providerId === this.bindingForm.providerId);
    },
    bindingEnvironment() {
      return (this.selectedBindingProvider && this.selectedBindingProvider.environment) || (this.selectedBindingTemplate && this.selectedBindingTemplate.environment) || "";
    },
    selectedBindingSender() {
      return this.senders.find((item) => item.senderProfileId === this.bindingForm.senderProfileId && (!this.bindingForm.providerId || item.providerId === this.bindingForm.providerId));
    },
    bindingProviders() {
      if (!this.selectedBindingTemplate || !this.bindingForm.senderProfileId) return [];
      const providerIds = this.senders.filter((item) => item.senderProfileId === this.bindingForm.senderProfileId && item.providerStatus === "APPROVED" && item.enabled).map((item) => item.providerId);
      return this.providers.filter((item) => providerIds.includes(item.providerId) && item.countryCode === this.selectedBindingTemplate.countryCode && item.environment === this.selectedBindingTemplate.environment);
    },
    eligibleBindingSenders() {
      const template = this.selectedBindingTemplate;
      if (!template) return [];
      const unique = new Map();
      this.senders.filter((item) => item.countryCode === template.countryCode && item.environment === template.environment && item.providerStatus === "APPROVED" && item.enabled).forEach((item) => unique.set(item.senderProfileId, item));
      return Array.from(unique.values());
    },
    templateSenderOptions() {
      const unique = new Map();
      this.senders.filter((item) => item.countryCode === this.templateForm.countryCode && item.environment === this.templateForm.environment && item.providerStatus === "APPROVED" && item.enabled).forEach((item) => unique.set(item.senderProfileId, item));
      return Array.from(unique.values());
    },
    templateProviderOptions() {
      if (!this.templateForm.senderProfileId) return [];
      const providerIds = this.senders.filter((item) => item.senderProfileId === this.templateForm.senderProfileId && item.countryCode === this.templateForm.countryCode && item.environment === this.templateForm.environment && item.providerStatus === "APPROVED" && item.enabled).map((item) => item.providerId);
      return this.providers.filter((item) => providerIds.includes(item.providerId) && item.countryCode === this.templateForm.countryCode && item.environment === this.templateForm.environment);
    },
    selectedTemplateSender() {
      return this.templateSenderOptions.find((item) => item.senderProfileId === this.templateForm.senderProfileId);
    },
    selectedTemplateProvider() {
      return this.templateProviderOptions.find((item) => item.providerId === this.templateForm.providerId);
    },
    senderProviderOptions() {
      return this.providers.filter((item) => item.countryCode === this.senderForm.countryCode && item.environment === this.configurationEnvironment);
    },
    selectedSenderScope() {
      return `${this.countryLabel(this.senderForm.countryCode)}：仅可关联当前环境的短信通道`;
    },
    selectedSenderChannels() {
      return (this.senderForm.providerIds || []).map((providerId) => {
        const provider = this.providers.find((item) => item.providerId === providerId) || { providerId, providerName: providerId };
        const registration = this.senders.find((item) => item.senderProfileId === this.senderEditId && item.providerId === providerId);
        return { ...provider, registration };
      });
    },
  },
  watch: {
    '$route.meta.smsSection': function (section) {
      this.active = section || 'templates';
      this.resetEditor();
    },
    providerFilter: { deep: true, handler() { this.providerPage = 1; } },
    senderFilter: { deep: true, handler() { this.senderPage = 1; } },
    templateFilter: { deep: true, handler() { this.templatePage = 1; } },
    bindingFilter: { deep: true, handler() { this.bindingPage = 1; } },
  },
  created() {
    this.active = this.$route.meta.smsSection || "templates";
    this.reload();
  },
  methods: {
    async reload() {
      this.loading = true;
      try {
        const [capabilities, smsRuntime, providers, senders, templates, bindings] = await Promise.all([getAdminCapabilities(), getSmsRouteV2Runtime(), ...["providers", "senders", "templates", "bindings"].map(getSmsConfig)]);
        this.configurationEnvironment = smsRuntime.configurationEnvironment || capabilities.runtimeEnvironment || "test";
        this.providers = providers;
        this.senders = senders;
        this.templates = templates;
        this.bindings = bindings;
      } catch (error) {
        this.$message.error("短信配置加载失败");
      } finally {
        this.loading = false;
        this.$nextTick(() => this.layoutTables());
      }
    },
    async refreshRouteTemplates() {
      await this.$nextTick();
      const routePanel = this.$refs.routeV2Panel;
      if (routePanel && typeof routePanel.load === "function") await routePanel.load();
    },
    layoutTables() {
      ["providerTable", "senderTable", "templateTable", "bindingTable"].forEach((name) => {
        const table = this.$refs[name];
        if (table && typeof table.doLayout === "function") table.doLayout();
      });
      const routePanel = this.$refs.routeV2Panel;
      if (routePanel && typeof routePanel.doLayout === "function") routePanel.doLayout();
    },
    resetEditor() {
      this.providerEditVisible = false;
      this.senderEditVisible = false;
      this.templateEditVisible = false;
      this.templateCreateVisible = false;
      this.bindingEditVisible = false;
      this.providerEditId = null;
      this.senderEditId = null;
      this.templateEditId = null;
      this.templateCodeEdited = false;
      this.bindingEditId = null;
      this.providerForm = blankProvider();
      this.senderForm = blankSender();
      this.templateForm = blankTemplate();
      this.bindingForm = blankBinding();
    },
    selectedProviderScope(id) {
      const item = this.providers.find((provider) => provider.providerId === id);
      return item ? `${item.countryCode} / ${this.environmentLabel(item.environment)}` : "请先选择短信通道";
    },
    environmentLabel(value) {
      return value === "production" ? "生产" : value === "uat" ? "UAT" : "测试";
    },
    countryLabel(value) {
      return value === "GH" ? "加纳 GH" : value === "NG" ? "尼日利亚 NG" : value || "—";
    },
    senderAccountCodePlaceholder(provider) {
      return provider && provider.providerCode === "uspeedo_sms_provider"
        ? "例如 60210183"
        : "该通道账号编码（可选）";
    },
    senderAccountCodeLabel(provider) {
      return provider && provider.providerCode === "uspeedo_sms_provider" ? "Account ID" : "账号";
    },
    senderCountryChanged() {
      this.senderForm.providerIds = [];
      this.senderForm.registrationAccountCodes = {};
      this.refreshSenderProfileCode();
    },
    refreshSenderProfileCode() {
      if (this.senderEditId) return;
      const part = (value) => String(value || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "sender";
      const providerCodes = this.senderForm.providerIds
        .map((id) => this.providers.find((item) => item.providerId === id))
        .filter(Boolean)
        .map((item) => part(item.providerCode))
        .sort();
      const code = `${part(this.senderForm.countryCode)}_${part(this.senderForm.senderId)}_${providerCodes.join("_") || "channel"}`;
      this.senderForm.profileCode = code.slice(0, 60).replace(/_+$/g, "");
    },
    rowIndex(page) {
      return (index) => (page - 1) * this.pageSize + index + 1;
    },
    isLatestTemplate(item) {
      return this.latestTemplateIds.has(item.templateId);
    },
    showRowRemark(row, column, cell) {
      const remark = String((row && row.remark) || "").trim();
      if (!remark || !cell) return;
      const tableRow = cell.closest("tr");
      if (!tableRow) return;
      tableRow.querySelectorAll("td").forEach((item) => item.setAttribute("title", `备注：${remark}`));
    },
    clearRowRemark(row, column, cell) {
      if (!cell) return;
      const tableRow = cell.closest("tr");
      if (!tableRow) return;
      tableRow.querySelectorAll("td").forEach((item) => item.removeAttribute("title"));
    },
    applyFilters(section) {
      const pageBySection = { providers: "providerPage", senders: "senderPage", templates: "templatePage", bindings: "bindingPage" };
      this[pageBySection[section]] = 1;
    },
    resetFilters(section) {
      const filterBySection = {
        providers: { keyword: "", countryCode: "", environment: "", enabled: "" },
        senders: { providerId: "", countryCode: "", category: "", status: "", enabled: "", keyword: "" },
        templates: { keyword: "", countryCode: "", productLine: "", versionScope: "latest", state: "" },
        bindings: { keyword: "", providerId: "", environment: "", state: "" },
      };
      const propertyBySection = { providers: "providerFilter", senders: "senderFilter", templates: "templateFilter", bindings: "bindingFilter" };
      this[propertyBySection[section]] = filterBySection[section];
      this.applyFilters(section);
    },
    providerReadiness(provider) {
      if (!provider.enabled) return { label: "通道停用", type: "info" };
      const bindings = this.bindings.filter((item) => item.providerId === provider.providerId && item.enabled && item.selectedForSending);
      if (!bindings.length) return { label: "没有模板选择该通道发送", type: "warning" };
      if (provider.senderRequired) {
        const ready = bindings.some((binding) => this.senders.some((item) => item.senderProfileId === binding.senderProfileId && item.providerId === provider.providerId && item.providerStatus === "APPROVED" && item.enabled));
        if (!ready) return { label: "Sender ID 不可用", type: "danger" };
      }
      return { label: "可发送", type: "success" };
    },
    cancelEdit() {
      if (!this.providerEditVisible && !this.senderEditVisible && !this.templateEditVisible && !this.templateCreateVisible && !this.bindingEditVisible) this.resetEditor();
    },
    editProvider(row) {
      this.active = "providers";
      this.providerEditId = row.providerId;
      this.providerForm = { ...blankProvider(), ...row };
      this.providerEditVisible = true;
    },
    openProviderCreate() {
      this.providerEditId = null;
      this.providerForm = blankProvider();
      this.providerForm.environment = this.configurationEnvironment;
      this.providerEditVisible = true;
    },
    editSender(row) {
      this.active = "senders";
      this.senderEditId = row.senderProfileId;
      const registrations = this.senders.filter((item) => item.senderProfileId === row.senderProfileId);
      const registrationAccountCodes = {};
      registrations.forEach((item) => { registrationAccountCodes[item.providerId] = item.accountCode || ""; });
      this.senderForm = { ...blankSender(), ...row, categories: String(row.category || "").split(",").filter(Boolean), providerIds: registrations.map((item) => item.providerId), registrationAccountCodes };
      this.senderEditVisible = true;
    },
    senderProviderRemovalLocked(providerId) {
      if (!this.senderEditId) return false;
      const registration = this.senders.find((item) => item.senderProfileId === this.senderEditId && item.providerId === providerId);
      return Boolean(registration && (registration.providerStatus !== "DRAFT" || registration.enabled));
    },
    openSenderCreate() {
      this.senderEditId = null;
      this.senderForm = blankSender();
      this.refreshSenderProfileCode();
      this.senderEditVisible = true;
    },
    editTemplate(row) {
      this.active = "templates";
      this.templateEditId = row.templateId;
      this.templateCodeEdited = true;
      this.templateForm = { ...blankTemplate(), ...row };
      this.templateEditVisible = true;
    },
    editBinding(row) {
      this.active = "legacyBindings";
      this.bindingEditId = row.bindingId;
      this.bindingForm = { ...blankBinding(), ...row, parameterOrder: [...(row.effectiveParameterOrder || row.parameterOrder || [])] };
      this.bindingEditVisible = true;
    },
    openBindingCreate() {
      this.bindingEditId = null;
      this.bindingForm = blankBinding();
      this.bindingEditVisible = true;
    },
    resetBindingSelection() {
      this.bindingForm.senderProfileId = "";
      this.bindingForm.providerId = "";
      this.bindingForm.parameterOrder = this.bindingTemplateVariables();
    },
    bindingTemplateVariables() {
      const content = (this.selectedBindingTemplate && this.selectedBindingTemplate.contentTemplate) || "";
      const result = []; const seen = new Set(); const regex = /\{([A-Za-z][A-Za-z0-9_]*)\}/g; let match;
      while ((match = regex.exec(content)) !== null) { if (!seen.has(match[1])) { seen.add(match[1]); result.push(match[1]); } }
      return result;
    },
    bindingParameterDragStart(index) { this.bindingDraggedParameter = index; },
    bindingParameterDrop(index) { if (this.bindingDraggedParameter === null) return; const value = this.bindingForm.parameterOrder.splice(this.bindingDraggedParameter, 1)[0]; this.bindingForm.parameterOrder.splice(index, 0, value); this.bindingDraggedParameter = null; },
    bindingSenderChanged() {
      this.bindingForm.providerId = (this.bindingProviders[0] && this.bindingProviders[0].providerId) || "";
    },
    openProviderGuide() {
      this.providerGuideVisible = true;
    },
    startProviderOnboarding() {
      this.providerGuideVisible = false;
      this.active = "providers";
      this.resetEditor();
      this.openProviderCreate();
    },
    openTemplateCreate() {
      this.templateEditId = null;
      this.templateCodeEdited = false;
      this.templateForm = blankTemplate();
      this.templateForm.environment = this.configurationEnvironment;
      this.templateCreateVisible = true;
    },
    cancelTemplateCreate() {
      if (!this.templateCreateVisible) {
        this.templateCodeEdited = false;
        this.templateForm = blankTemplate();
      }
    },
    async saveProvider() {
      await this.save(() => (this.providerEditId ? updateSmsConfig("providers", this.providerEditId, this.providerForm) : createSmsConfig("providers", this.providerForm)));
    },
    async saveSender() {
      if (!this.senderForm.providerIds.length) return this.$message.warning("请至少选择一个短信通道");
      if (this.senderEditId) {
        await this.save(() => updateSmsConfig("senders", this.senderEditId, this.senderForm));
        return;
      }
      const duplicate = this.senders.find((item) => String(item.senderId || "").trim().toLowerCase() === String(this.senderForm.senderId || "").trim().toLowerCase() && item.countryCode === this.senderForm.countryCode);
      if (!duplicate) {
        await this.save(() => createSmsConfig("senders", this.senderForm));
        return;
      }
      try {
        await this.$confirm(`“${duplicate.senderId}”已在 ${this.countryLabel(duplicate.countryCode)} 的其他短信通道报备。确认合并所选短信通道到现有 Sender ID 吗？现有业务类型与已确认报备不会被改变。`, "发现相同 Sender ID", { type: "warning", confirmButtonText: "确认合并" });
      } catch (error) {
        return;
      }
      const registrations = this.senders.filter((item) => item.senderProfileId === duplicate.senderProfileId);
      const accountCodes = {};
      registrations.forEach((item) => { accountCodes[item.providerId] = item.accountCode || ""; });
      Object.assign(accountCodes, this.senderForm.registrationAccountCodes || {});
      const merged = {
        ...this.senderForm,
        senderId: duplicate.senderId,
        categories: String(duplicate.category || "").split(",").filter(Boolean),
        providerIds: Array.from(new Set(registrations.map((item) => item.providerId).concat(this.senderForm.providerIds))),
        registrationAccountCodes: accountCodes,
      };
      await this.save(() => updateSmsConfig("senders", duplicate.senderProfileId, merged));
    },
    async saveTemplate() {
      if (!this.validateTemplateForm()) return;
      await this.save(() => (this.templateEditId ? updateSmsConfig("templates", this.templateEditId, this.templateForm) : createSmsConfig("templates", this.templateForm)));
    },
    validateTemplateForm() {
      if (!this.templateEditId && !this.templateCodeEdited) this.generateTemplateCode();
      const requiredFields = [
        ["templateName", "模板名称"],
        ["productLine", "产品线"],
        ["templateCode", "模板编码"],
        ["countryCode", "国家"],
        ["scene", "场景"],
        ["messageType", "运营分类"],
        ["languageCode", "语言"],
        ["contentTemplate", "模板文本"],
      ];
      const missing = requiredFields.find(([field]) => !String(this.templateForm[field] || "").trim());
      if (missing) {
        this.$message.warning(`请填写${missing[1]}`);
        return false;
      }
      if (!this.templateEditId && this.templateCodeExists(this.templateForm.templateCode)) {
        this.$message.warning("模板编码在当前国家下已存在，请修改模板编码");
        return false;
      }
      if (!this.templateEditId) {
        const productCode = String(this.templateForm.productLine).toLowerCase();
        const code = String(this.templateForm.templateCode).trim();
        const requiredSuffix = `_${productCode}`;
        if (!/^[a-z][a-z0-9_]*$/.test(code) || !(code.endsWith(requiredSuffix) || new RegExp(`_\\d+${requiredSuffix}$`).test(code))) {
          this.$message.warning(`新模板编码须为小写 snake_case，并以 ${requiredSuffix} 结尾`);
          return false;
        }
      }
      const content = this.templateForm.contentTemplate || "";
      if (/\{\{|}}|\{\d+}/.test(content)) {
        this.$message.warning("模板变量必须使用 {otp} 这类命名占位符，不支持 {1} 或 {{otp}}");
        return false;
      }
      this.syncTemplateVariableRules();
      return true;
    },
    syncTemplateVariableRules() {
      const content = this.templateForm.contentTemplate || "";
      let existing = {};
      try { existing = JSON.parse(this.templateForm.variableRulesJson || "{}"); } catch (error) { existing = {}; }
      const rules = {};
      Array.from(content.matchAll(/\{([A-Za-z][A-Za-z0-9_]*)}/g)).forEach((match) => {
        const name = match[1];
        if (!Object.prototype.hasOwnProperty.call(rules, name)) rules[name] = existing[name] || "text";
      });
      this.templateForm.variableRulesJson = JSON.stringify(rules, null, 2);
    },
    templateNameChanged() {
      if (!this.templateCodeEdited) this.generateTemplateCode();
    },
    templateProductLineChanged() {
      this.templateScopeChanged();
      if (!this.templateCodeEdited) this.generateTemplateCode();
    },
    templateScopeChanged() {
      this.templateForm.senderProfileId = "";
      this.templateForm.providerId = "";
      this.templateForm.providerTemplateId = "";
      if (!this.templateCodeEdited) this.generateTemplateCode();
    },
    templateSenderChanged() {
      this.templateForm.providerId = this.templateProviderOptions.length === 1 ? this.templateProviderOptions[0].providerId : "";
      this.templateProviderChanged();
    },
    templateProviderChanged() {
      if (!this.selectedTemplateProvider || this.selectedTemplateProvider.templateMode === "RAW_CONTENT") this.templateForm.providerTemplateId = "";
    },
    templateCodeChanged(value) {
      this.templateCodeEdited = Boolean(String(value || "").trim());
      if (!this.templateCodeEdited) this.generateTemplateCode();
    },
    generateTemplateCode() {
      const nameInitials = pinyin(String(this.templateForm.templateName || "").trim(), { pattern: "first", toneType: "none", type: "array" }).join("");
      const nameCode = nameInitials.toLowerCase().replace(/['’]/g, "").replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      const productCode = String(this.templateForm.productLine || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      const suffix = productCode ? `_${productCode}` : "";
      const maxNameLength = Math.max(0, 64 - suffix.length);
      const baseCode = `${nameCode.slice(0, maxNameLength).replace(/_+$/g, "")}${suffix}`.replace(/^_+|_+$/g, "");
      this.templateForm.templateCode = this.uniqueTemplateCode(baseCode);
    },
    templateCodeExists(templateCode) {
      const normalized = String(templateCode || "").toLowerCase();
      return this.templates.some((item) => String(item.templateCode || "").toLowerCase() === normalized && item.countryCode === this.templateForm.countryCode);
    },
    uniqueTemplateCode(baseCode) {
      if (!baseCode || !this.templateCodeExists(baseCode)) return baseCode;
      const productCode = String(this.templateForm.productLine || "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
      const productSuffix = productCode ? `_${productCode}` : "";
      const actionCode = productSuffix && baseCode.endsWith(productSuffix) ? baseCode.slice(0, -productSuffix.length) : baseCode;
      let sequence = 2;
      let candidate = baseCode;
      do {
        const sequenceSuffix = `_${sequence}${productSuffix}`;
        candidate = `${actionCode.slice(0, 64 - sequenceSuffix.length).replace(/_+$/g, "")}${sequenceSuffix}`;
        sequence += 1;
      } while (this.templateCodeExists(candidate));
      return candidate;
    },
    async saveBinding() {
      await this.save(() => (this.bindingEditId ? updateSmsConfig("bindings", this.bindingEditId, this.bindingForm) : createSmsConfig("bindings", this.bindingForm)));
    },
    async save(request) {
      if (this.saving) return;
      this.saving = true;
      try {
        await request();
        this.$message.success("已保存，操作记录已更新");
        this.resetEditor();
        await this.reload();
        await this.refreshRouteTemplates();
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.message) || "保存失败");
      } finally {
        this.saving = false;
      }
    },
    async runAction(resource, id, action) {
      const key = this.actionKey(resource, id, action);
      try {
        if (action === "DISABLE" || action === "SELECT_FOR_SENDING") {
          await this.$confirm(`确认${this.actionLabel(action)}？`, "确认操作", { type: "warning" });
        }
        this.$set(this.actionLoading, key, true);
        await smsConfigAction(resource, id, action);
        this.$message.success("操作记录已更新");
        await this.reload();
      } catch (error) {
        if (error !== "cancel") this.$message.error((error.response && error.response.data && error.response.data.message) || "操作失败");
      } finally {
        this.$delete(this.actionLoading, key);
      }
    },
    async showOperations(targetType, targetId) {
      try {
        this.operationsTitle = "操作记录";
        this.operations = await getSmsConfigOperations(targetType, targetId);
        this.operationsVisible = true;
      } catch (error) {
        this.$message.error("操作记录加载失败");
      }
    },
    actionKey(resource, id, action) {
      return `${resource}:${id}:${action}`;
    },
    isActionLoading(resource, id, action) {
      return Boolean(this.actionLoading[this.actionKey(resource, id, action)]);
    },
    actionLabel(action) {
      return ({
        ENABLE: "启用",
        DISABLE: "停用",
        SUBMIT: "提交报备",
        MARK_APPROVED: "标记为已确认",
        PUBLISH: "发布",
        SELECT_FOR_SENDING: "将该组合设为当前发送配置",
      })[action] || `执行 ${action} 操作`;
    },
    onTabChange(tab) {
      this.resetEditor();
      this.$nextTick(async () => {
        this.layoutTables();
        if (tab.name === "bindings") await this.refreshRouteTemplates();
      });
      const routeBySection = { providers: "sms-config-providers", senders: "sms-config-senders", templates: "sms-config-templates", bindings: "sms-config-routes", legacyBindings: "sms-config-legacy-bindings" };
      const target = routeBySection[tab.name];
      if (target && this.$route.name !== target) this.$router.push({ name: target, query: this.$route.query });
    },
    bindingSaveLabel() {
      if (!this.bindingEditId) return "创建草稿配置";
      const binding = this.bindings.find((item) => item.bindingId === this.bindingEditId);
      return binding && binding.operationState === "PUBLISHED" ? "保存并对后续发送生效" : "保存草稿修改";
    },
    paginate(items, page) {
      const start = (page - 1) * this.pageSize;
      return items.slice(start, start + this.pageSize);
    },
    formatDate(value) {
      return value ? String(value).replace("T", " ") : "—";
    },
  },
};
</script>

<style scoped>
.page-intro {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: flex-start;
  padding: 22px;
}
.page-intro h2 {
  margin: 4px 0 8px;
}
.page-intro p {
  margin: 0;
  color: #6b7280;
}
.editor-card {
  padding: 20px;
  margin-bottom: 16px;
}
.editor-card h3 {
  margin-top: 0;
}
.is-editing .editor-card {
  display: none;
}
.template-list-mode .editor-card {
  display: none;
}
.sender-list-mode .editor-card {
  display: none;
}
.list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
}
.list-toolbar h3,
.list-toolbar p {
  margin: 0;
}
.list-toolbar p {
  margin-top: 4px;
  color: #6b7280;
}
.compact-form .el-select {
  width: 100%;
}
.compact-form .el-input-number {
  width: 100%;
}
.sender-toolbar {
  margin-bottom: 0;
}
.sender-filters {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  padding: 16px 20px;
}
.config-filter-bar {
  display: grid;
  grid-template-columns: minmax(220px, 2fr) repeat(3, minmax(140px, 1fr));
  gap: 12px;
  padding: 16px 20px;
  margin-bottom: 12px;
}
.config-filter-bar .el-select {
  width: 100%;
}
.config-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 4px 4px;
}
.sender-filters .el-select {
  width: 100%;
}
.sender-summary {
  display: flex;
  gap: 10px;
  align-items: center;
  color: #6b7280;
}
.sender-summary span:first-child {
  margin-right: auto;
}
.sender-channel-list {
  margin: -4px 0 18px 112px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.sender-channel-row {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) minmax(220px, 1.4fr) 90px;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  background: #f8fafc;
}
.sender-channel-row + .sender-channel-row {
  border-top: 1px solid #e2e8f0;
}
.sender-channel-row span,
.sender-channel-row small {
  display: block;
}
.sender-channel-row small {
  margin-top: 3px;
  color: #6b7280;
}
.sender-channel-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.sender-channel-options .el-checkbox.is-bordered {
  width: 100%;
  height: auto;
  min-height: 54px;
  margin: 0;
  padding: 10px 12px;
  display: flex;
  align-items: center;
}
.sender-channel-options strong,
.sender-channel-options small {
  display: block;
}
.sender-channel-options small {
  margin-top: 3px;
  color: #6b7280;
}
.template-content-cell {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.5;
  white-space: normal;
}
.table-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
  white-space: nowrap;
}
.table-actions .el-button {
  margin: 0;
}
.template-dialog .el-alert {
  margin-bottom: 18px;
}
.template-dialog .el-dialog__body {
  max-height: 76vh;
  overflow-y: auto;
}
.task-entry-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.task-entry {
  border: 0;
  padding: 22px;
  text-align: left;
  cursor: pointer;
  display: grid;
  gap: 8px;
  color: #1f2937;
}
.task-entry:hover {
  box-shadow: 0 10px 28px rgba(31, 41, 55, 0.12);
  transform: translateY(-1px);
}
.task-entry strong {
  font-size: 18px;
}
.task-entry small,
.task-progress p,
.advanced-title span,
.field-help {
  color: #6b7280;
}
.binding-parameter-order {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.parameter-chip {
  padding: 5px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f5f7fa;
  cursor: grab;
}
.task-entry em {
  color: #2563eb;
  font-style: normal;
  font-weight: 600;
}
.task-index {
  color: #94a3b8;
  font-size: 12px;
  letter-spacing: 0.12em;
}
.task-progress {
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
}
.task-progress h3,
.task-progress p {
  margin: 0;
}
.task-progress p {
  margin-top: 5px;
}
.task-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.advanced-title {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 8px 2px -4px;
}
.advanced-title strong {
  font-size: 17px;
}
.binding-form {
  margin-top: 16px;
}
.field-help {
  display: block;
  line-height: 1.45;
  margin-top: 6px;
}
.send-preview {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 16px;
  margin: 0 0 16px 112px;
  display: grid;
  gap: 6px;
}
.guide-copy {
  margin-top: 24px;
  line-height: 1.7;
}
.guide-copy h3 {
  margin-bottom: 4px;
}
@media (max-width: 900px) {
  .task-entry-grid {
    grid-template-columns: 1fr;
  }
  .task-progress {
    align-items: flex-start;
    flex-direction: column;
  }
  .task-chips {
    justify-content: flex-start;
  }
  .send-preview {
    margin-left: 0;
  }
  .sender-channel-list {
    margin-left: 0;
  }
  .sender-channel-row {
    grid-template-columns: 1fr;
  }
  .sender-filters {
    grid-template-columns: 1fr;
  }
  .config-filter-bar {
    grid-template-columns: 1fr;
  }
}
</style>
